<template>
  <div class="m-0 checkboxWrapper">
    <ValidationProvider
      :rules="validation"
      v-slot="{ errors }"
    >
      <div
        class="wrapper_best"
        :style="styles"
      >
        <div class="custom-control custom-checkbox custom-checkbox-arrow pt-1">
          <input
            v-model="localChecked"
            :name="validationName"
            :checked="checked"
            type="checkbox"
            class="custom-control-input"
            :id="`checkbox_${fieldId}`"
            required
          />
          <label
            class="custom-control-label text_min"
            :for="`checkbox_${fieldId}`"
          ></label>
        </div>
        <div>

          <label
            style="width:100%;"
            v-html="$t(label)"
          ></label>
          <div class="d-flex flex-row">
            <div
              role="button"
              data-toggle="collapse"
              data-target="#immer-up-to-date"
              aria-expanded="false"
              :aria-controls="fieldId"
            >
            </div>
          </div>
          <div
            class="collapse"
            id="immer-up-to-date"
          >
            <div class="card card-body card-body-dop">
            </div>
          </div>
        </div>
        <div
          role="button"
          data-toggle="collapse"
          :data-target="`#${fieldId}`"
          aria-expanded="false"
          :aria-controls="fieldId"
        >
          <img
            v-if="expandable"
            class="down-arrow"
            src="../../assets/icons/form/down-arrow.svg"
            alt
          />
        </div>
      </div>
      <div
        v-if="expandable"
        class="collapse"
        :id="fieldId"
      >
        <div
          class="card card-body card-body-dop"
          v-html="expandableText"
        ></div>
      </div>
      <div
        class="validation-error checkbox-error"
        v-if="errors.length"
      >
        <img
          class="error_min"
          src="../../assets/icons/form/error.svg"
          alt
        />
        <span v-html="validationMessage ? $t(validationMessage): errors[0]"></span>
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  name: "checkbox-terms",
  data () {
    return {
      localChecked: this.checked
    };
  },
  computed: {
    // label (val) {
    //   return this.$t('I confirm that I am over 18 years old. I have read and accept the terms and conditions.');
    // },
    // selectedProduct () {
    //   if (
    //     this.$store.getters.selectedProduct(this.selectionComponentId) &&
    //     this.$store.getters.selectedProduct(this.selectionComponentId).selected
    //   )
    //     return this.$store.getters.selectedProduct(this.selectionComponentId)
    //       .selected;

    //   return {};
    // }
  },
  props: {
    name: {
      type: String,
      required: true
    },
    selectionComponentId: {
      required: false,
      type: String
    },
    expandable: {
      required: false,
      type: Boolean,
      default: false
    },
    expandableText: {
      required: false,
      type: String,
      default: ""
    },
    checked: {
      required: false,
      type: Boolean,
      default: false
    },
    fieldId: {
      type: String,
      required: true
    },
    validation: {
      type: [String, Object],
      required: false,
      default: ""
    },
    validationName: {
      required: false,
      type: String,
      default: ""
    },
    validationMessage: {
      required: false,
      type: String,
      default: ""
    },
    checkOnClick: {
      required: false,
      type: Boolean,
      default: false
    },
    styles: {
      type: Object,
      required: false,
      default: () => {}
    },
    label: {
      type: String,
      required: true,
      default: ""
    }
  },
  mounted () {
    this.$emit("component-updated", {
      checked: !!this.checked
    });
    this.$emit("input", !!this.checked);
  },
  watch: {
    localChecked (value) {
      this.$emit("component-updated", {
        checked: value
      });
      this.$emit("input", value);
      // this.$eventHub.$emit('checkbox-event', { id: this.fieldId, checked: value ? '1' : '0' });
    }
  }
};
</script>

<style lang="scss" scoped>
$medium: 800px;

.checkboxWrapper {
  padding: 5px;
}
.form-group {
  margin-bottom: 20px;
}
.form-field {
  margin-bottom: 20px;
}
.wrapper_input {
  position: relative;
}
.form-field__label {
  position: absolute;
  top: 50%;
  left: 10px;
  padding-left: 7px;
  padding-right: 7px;
  transition: transform 0.1s;
  pointer-events: none;
  transform-origin: 0 100%;
  transform: translateY(-50%);
  font-size: 14px;
  letter-spacing: 0.14px;
  line-height: 16px;
}
.form-field__input {
  background: transparent !important;
  outline: 0;
  box-shadow: none;
  transition: border-color 0.15s;
  border-radius: 0px !important;
  border: 1px solid #808080 !important;
  box-sizing: border-box !important;
  padding-left: 15px !important;
  height: 48px !important;
  cursor: pointer;
  width: 100%;
  font-size: 14px;
}
.form-field__input:focus + .form-field__label,
.form-field__input.visited + .form-field__label {
  transform: translateY(-140%) scale(0.7);
}
.wrapper-i {
  cursor: pointer;
}
.wrapper_weit {
  display: flex;
  align-items: center;
}
.information-img {
  width: 18px;
}
.add-img {
  width: 30px;
  margin-right: 20px;
}
.is-invalid {
  .form-field__input {
    border-color: #ff5a5a !important;
  }
  .invalid-feedback {
    display: block;
  }
}
.wrapper_best {
  display: flex;
  position: relative;
  @media only screen and (max-width: $medium) {
    // margin-left: 30px;
    // margin-right: 20px;
  }
  .custom-control {
    padding-left: 35px;
  }
  .custom-checkbox .custom-control-label::before,
  .custom-checkbox .custom-control-label::after {
    left: -35px;
  }
}
.down-arrow {
  width: 16px;
  transition: all 0.3s;
  margin-left: 10px;
  margin-top: -8px;
}
.down-arrow[aria-expanded="true"] {
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}
.card-body-dop {
  border: none;
  padding-left: 35px;
}
.custom-radio {
  padding-left: 35px;
  margin-right: 20px;
}
.custom-control-label::after,
.custom-checkbox .custom-control-label::before {
  width: 20px;
  height: 20px;
  top: -3px;
  left: -35px;
}
.custom-checkbox-dop {
  position: absolute;
  bottom: 5px;
  right: 10px;
  .custom-control-label {
    &:after,
    &:before {
      left: -20px;
    }
  }
}
.custom-control-label::after,
.custom-checkbox .custom-control-label::before,
.custom-control-input[type="radio"] {
  background-color: transparent !important;
  width: 20px;
  height: 20px;
  border: none;
  border-radius: 0px;
}
.custom-checkbox .custom-control-label::before {
  background-color: #fff !important;
  background-image: url("../../assets/icons/form/checkmark_big_steps.svg") !important;
  background-repeat: no-repeat;
  box-shadow: none !important;
  background-size: 12px;
  border: 1px solid #707070 !important;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-color: var(--brand-color-1) !important;
  background-image: none !important;
  background-image: url("../../assets/icons/form/checkmark_big_steps.svg") !important;
  background-repeat: no-repeat;
  background-size: 12px;
  border: 1px solid var(--brand-color-1) !important;
}
.text_min {
  font-size: 14px;
  letter-spacing: 0.14px;
  line-height: 16px;
}
</style>
